import React from "react";
import {
  NumberInput,
  Create,
  required,
  List,
  Datagrid,
  TextField,
  DateField,
  SimpleForm,
  useListContext,
  Edit,
} from "react-admin";
import { SelectProviderInput } from "../Admin/Booking/SelectProviderIntput";
import { useMemo } from "react";

const ColoredDatagrid = (props) => {
  const { data } = useListContext();
  const activeIds = useMemo(() => {
    const map = new Map();

    if (!data) return map;

    const ordered = [...data].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    ordered.forEach((rec) => {
      const provId = rec.provider?._id;
      if (provId && !map.has(provId)) {
        map.set(provId, rec._id);
      }
    });

    return map;
  }, [data]);

  const rowStyle = (record) =>
    activeIds.get(record.provider?._id) === record._id && record.currentMonthTotal >= record.monthlyThreshold
      ? { backgroundColor: "#E8F5E9" } // verde suave
      : {};

  return <Datagrid rowStyle={rowStyle} bulkActionButtons={false} {...props} rowClick={"edit"} />;
};
export const CommissionList = (props) => {
  return (
    <List {...props}>
      <ColoredDatagrid>
        <TextField source="rate" label="Comisión (%)" />
        <DateField source="createdAt" label="Válido desde:" showTime locales="es-ES" />
        <TextField source="currentMonthTotal" label="Monto actual (Bs)" />
        <TextField source="monthlyThreshold" label="Monto Mínimo (Bs)" />
        {/* <TextField source="currentMonthEarnings" label="Ganancias del mes (Bs)" /> */}
        <TextField source="provider.first_name" label="Proveedor" />
      </ColoredDatagrid>
    </List>
  );
};

export const CommissionEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect="/commission">
      <NumberInput source="rate" label="Comisión (%)" inputProps={{ min: 0, max: 100 }} validate={[required()]} />
      <NumberInput
        source="monthlyThreshold"
        label="Monto mínimo mensual (Bs.)"
        inputProps={{ min: 0 }}
        validate={[required()]}
      />
    </SimpleForm>
  </Edit>
);
export const CommissionCreate = (props) => (
  <Create {...props} redirect="/commission">
    <SimpleForm>
      <SelectProviderInput source="providerId" label="Proveedor" alwaysOn />
      <NumberInput
        source="rate"
        label="Comisión(%)"
        placeholder="%"
        inputProps={{
          min: 0,
          max: 100,
        }}
        validate={[required()]}
      />
      <NumberInput
        source="monthlyThreshold"
        label="Monto mínimo mensual (Bs.)"
        placeholder="Ej: 10000"
        inputProps={{ min: 0 }}
        validate={[required()]}
      />
    </SimpleForm>
  </Create>
);
